import { $post } from "app/utilities/HttpClient";

interface ImageUploadOptions {
  file: File;
  startLoading? (): void;
  endLoading? (): void;
  callback? (imageUrl: string): void;
}

export default async function uploadImage(options: ImageUploadOptions): Promise<string | null> {
  const { file, startLoading, endLoading, callback } = options;
  startLoading && startLoading();
  try {
    const data = { file: { name: file.name, contentType: file.type } };
    const response: Response = await $post('/content/uploads/presignedUrls', data);
    const { uploadUrl, downloadUrl: imageUrl } = await response.json();
    await fetch(uploadUrl, { method: 'PUT', body: file });
    callback && callback(imageUrl);
    return imageUrl;
  } catch (error) {
    return null;
  } finally {
    endLoading && endLoading();
  }
}